import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line
export function CrossIcon(props) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 512, height: 512 }, props, { children: _jsx("path", { d: "M24 1.414 22.586 0 12 10.586 1.414 0 0 1.414 10.586 12 0 22.586 1.414 24 12 13.414 22.586 24 24 22.586 13.414 12 24 1.414z", "data-name": "01 align center" }) })));
}
//# sourceMappingURL=CrossIcon.js.map